import { render, staticRenderFns } from "./Art.vue?vue&type=template&id=5bf5cfcc&scoped=true"
import script from "./Art.vue?vue&type=script&lang=js"
export * from "./Art.vue?vue&type=script&lang=js"
import style0 from "./Art.vue?vue&type=style&index=0&id=5bf5cfcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf5cfcc",
  null
  
)

export default component.exports